import { render, staticRenderFns } from "./ticket-prices-import.vue?vue&type=template&id=1fd94a7b&scoped=true&"
import script from "./ticket-prices-import.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-import.vue?vue&type=script&lang=js&"
import style0 from "./ticket-prices-import.vue?vue&type=style&index=0&id=1fd94a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd94a7b",
  null
  
)

export default component.exports